import type { ReactNode } from "react";

interface PageHeaderProps {
	title: ReactNode;
	description?: ReactNode;
	actions?: ReactNode;
}

/** Page title row inside the content area (below the app top bar). */
export function PageHeader({ title, description, actions }: PageHeaderProps) {
	return (
		<div className="flex flex-wrap items-end justify-between gap-3">
			<div className="min-w-0">
				<h1 className="text-lg font-semibold tracking-tight">{title}</h1>
				{description && <p className="mt-0.5 text-sm text-muted">{description}</p>}
			</div>
			{actions && <div className="flex items-center gap-2">{actions}</div>}
		</div>
	);
}
